// Configuração da experiência cinematográfica do sonar.
// Vídeos e posters servidos pelo CDN de Assets (cache longo).

import scene1Poster from "../../public/cinematic/posters/scene-1.webp.asset.json";
import scene2Poster from "@/assets/scene-2.webp.asset.json";
import scene3Poster from "../../public/cinematic/posters/scene-3.webp.asset.json";
import scene4Poster from "../../public/cinematic/posters/scene-4.webp.asset.json";

const POSTERS: Record<number, string> = {
  1: scene1Poster.url,
  2: scene2Poster.url,
  3: scene3Poster.url,
  4: scene4Poster.url,
};

/** Posters estáticos (momentos-chave) para o fallback ?motion=reduce. */
export const posterSrc = (scene: number) => POSTERS[scene] ?? POSTERS[1];

export const isMobileViewport = () =>
  typeof window !== "undefined" && window.innerWidth < 768;

export const prefersReducedMotion = () => {
  if (typeof window === "undefined") return false;
  // A experiência animada é o padrão para todos (o movimento é controlado
  // pelo próprio scroll). O modo estático fica disponível via ?motion=reduce.
  const param = new URLSearchParams(window.location.search).get("motion");
  return param === "reduce";
};
